import { render, staticRenderFns } from "./Textbook.vue?vue&type=template&id=3668a2e2&scoped=true"
import script from "./Textbook.vue?vue&type=script&lang=js"
export * from "./Textbook.vue?vue&type=script&lang=js"
import style0 from "./Textbook.vue?vue&type=style&index=0&id=3668a2e2&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3668a2e2",
  null
  
)

export default component.exports